var _path, _path2, _path3, _circle, _circle2, _g, _circle3, _circle4, _g2, _circle5, _circle6, _g3, _circle7, _circle8, _g4, _circle9, _circle0, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 94,
    viewBox: "0 0 100 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1273_4325)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3047 48.6795H43.3047",
    stroke: "url(#paint0_linear_1273_4325)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1025 68.8397L63.305 60.6801",
    stroke: "url(#paint1_linear_1273_4325)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6758 27.6854L67.3118 35.0493",
    stroke: "url(#paint2_linear_1273_4325)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5009,
    cy: 20.8749,
    r: 6,
    transform: "rotate(-27.3941 40.5009 20.8749)",
    fill: "url(#paint3_linear_1273_4325)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1273_4325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 14,
    width: 13,
    height: 13
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.502,
    cy: 20.8776,
    r: 6,
    transform: "rotate(22.8352 40.502 20.8776)",
    fill: "url(#paint4_linear_1273_4325)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1273_4325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(-0.604109 -0.796902 -0.796902 0.604109 46.1182 16.3729)",
    fill: "white"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9648,
    cy: 75.3402,
    r: 10,
    transform: "rotate(-53.6717 69.9648 75.3402)",
    fill: "url(#paint5_linear_1273_4325)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1273_4325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 65,
    width: 21,
    height: 21
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9647,
    cy: 75.3396,
    r: 10,
    transform: "rotate(-150 69.9647 75.3396)",
    fill: "url(#paint6_linear_1273_4325)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1273_4325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 76.5 67.3397)",
    fill: "white"
  })))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3048,
    cy: 22.6794,
    r: 10,
    transform: "rotate(-60 79.3048 22.6794)",
    fill: "url(#paint7_linear_1273_4325)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1273_4325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 12,
    width: 21,
    height: 21
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3048,
    cy: 22.6796,
    r: 10,
    transform: "rotate(-60 79.3048 22.6796)",
    fill: "url(#paint8_linear_1273_4325)",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1273_4325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.3047,
    cy: 16.6795,
    r: 10,
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.3047,
    cy: 16.6797,
    r: 3,
    fill: "white"
  })))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3043,
    cy: 47.6842,
    r: 10,
    transform: "rotate(105 26.3043 47.6842)",
    fill: "url(#paint9_linear_1273_4325)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1273_4325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 37,
    width: 21,
    height: 21
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3032,
    cy: 47.6838,
    r: 10,
    transform: "rotate(164.456 26.3032 47.6838)",
    fill: "url(#paint10_linear_1273_4325)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1273_4325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5686,
    cy: 38.9475,
    r: 9,
    transform: "rotate(119.456 30.5686 38.9475)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(0.49176 -0.870731 -0.870731 -0.49176 35.1084 44.6266)",
    fill: "white"
  })))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.3062,
    cy: 46.6805,
    r: 16,
    transform: "rotate(-69.8332 58.3062 46.6805)",
    fill: "url(#paint11_linear_1273_4325)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1273_4325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 30,
    width: 33,
    height: 33
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.3116,
    cy: 46.6833,
    r: 16,
    transform: "rotate(82.5332 58.3116 46.6833)",
    fill: "url(#paint12_linear_1273_4325)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1273_4325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5166,
    cy: 38.502,
    r: 14,
    transform: "rotate(55.2724 65.5166 38.502)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1273_4325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.947,
    cy: 37.6777,
    r: 5,
    transform: "rotate(55.2724 64.947 37.6777)",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1273_4325",
    x: 34.1157,
    y: 7.39075,
    width: 17,
    height: 17.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1273_4325",
    x: 55.0352,
    y: 49.8749,
    width: 32.0015,
    height: 32.0013,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1273_4325",
    x: 61.3047,
    y: -5.3205,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1273_4325",
    x: 72.3047,
    y: 5.67969,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1273_4325",
    x: 9.56689,
    y: 17.946,
    width: 42.0034,
    height: 42.0031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1273_4325",
    x: 17.5918,
    y: 23.176,
    width: 32.0015,
    height: 32.0014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1273_4325",
    x: 36.5156,
    y: 9.50067,
    width: 58.0024,
    height: 58.0026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1273_4325",
    x: 51.9468,
    y: 24.6772,
    width: 26.0005,
    height: 26.0009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1273_4325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1273_4325",
    x1: 36.338,
    y1: 48.6795,
    x2: 36.8336,
    y2: 50.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1273_4325",
    x1: 65.7101,
    y1: 65.8478,
    x2: 67.4973,
    y2: 64.3623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1273_4325",
    x1: 71.9757,
    y1: 30.3855,
    x2: 69.9919,
    y2: 29.1381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1273_4325",
    x1: 35.482,
    y1: 18.0795,
    x2: 48.602,
    y2: 21.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#DD87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1273_4325",
    x1: 35.7091,
    y1: 10.5919,
    x2: 51.233,
    y2: 16.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142113,
    stopColor: "#CB4EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E4D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1273_4325",
    x1: 61.6001,
    y1: 70.6811,
    x2: 83.4666,
    y2: 75.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#DD87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1273_4325",
    x1: 61.0549,
    y1: 75.3396,
    x2: 81.2016,
    y2: 75.3396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#293CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7211F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1273_4325",
    x1: 71.3166,
    y1: 5.53655,
    x2: 97.1897,
    y2: 15.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142113,
    stopColor: "#C54A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A94F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1273_4325",
    x1: 71.3166,
    y1: 5.53673,
    x2: 97.1897,
    y2: 15.7754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142113,
    stopColor: "#C54A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A94F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1273_4325",
    x1: 21.9036,
    y1: 31.2633,
    x2: 37.5498,
    y2: 35.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1273_4325",
    x1: 23.8032,
    y1: 27.1838,
    x2: 38.0175,
    y2: 31.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1273_4325",
    x1: 100.701,
    y1: 60.1171,
    x2: 80.7985,
    y2: 76.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1273_4325",
    x1: 54.0449,
    y1: 30.6833,
    x2: 81.5626,
    y2: 42.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A3F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1273_4325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.26afdd29739594fb86457f3d9018e3d8.svg";
export { ForwardRef as ReactComponent };